import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getFirestore } from "firebase/firestore";

// Public Firebase web config. These values are safe to expose in client code
// (security is enforced by Firestore rules + Firebase Auth). We keep hardcoded
// fallbacks so production builds (e.g. Netlify) always work even if the build
// environment variables are not configured there.
const firebaseConfig = {
  apiKey: process.env.REACT_APP_FIREBASE_API_KEY || "AIzaSyBD7p8vqFXPnyeB8keQYUh_nXK3B8FL7bI",
  authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN || "frienddoors-ffa79.firebaseapp.com",
  projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID || "frienddoors-ffa79",
  storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET || "frienddoors-ffa79.firebasestorage.app",
  messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID || "896493820890",
  appId: process.env.REACT_APP_FIREBASE_APP_ID || "1:896493820890:web:9a3171d02642f09e6f7ee3",
  measurementId: process.env.REACT_APP_FIREBASE_MEASUREMENT_ID || "G-2F9XEME9R9",
};

export const app = initializeApp(firebaseConfig);
export const auth = getAuth(app);
export const db = getFirestore(app);
export const ADMIN_EMAIL = (process.env.REACT_APP_ADMIN_EMAIL || "admin@frienddoors.com").toLowerCase();

// Optional Firebase Analytics (guarded so it never breaks the app / preview iframe)
if (typeof window !== "undefined" && firebaseConfig.measurementId) {
  import("firebase/analytics")
    .then(({ getAnalytics, isSupported }) =>
      isSupported().then((ok) => {
        if (ok) {
          try { getAnalytics(app); } catch (_) { /* ignore */ }
        }
      })
    )
    .catch(() => { /* ignore analytics load errors */ });
}
